import { isDefined } from '@sgme/fp';
import { type PropsWithChildren, type ReactElement, useState } from 'react';

type Props = PropsWithChildren<{
  label: string;
  id: string;
  setIsContentExpanded?: (expanded: boolean) => void;
  dataE2e?: string;
}>;

export function Collapsible({ label, id, setIsContentExpanded, children, dataE2e }: Props): ReactElement {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  function handleToggleExpand() {
    const newValue = !isExpanded;

    setIsExpanded(newValue);
    if (isDefined(setIsContentExpanded)) {
      setIsContentExpanded(newValue);
    }
  }

  return (
    <div className="d-flex flex-column justify-content-center px-8px mt-8px">
      <div className="d-flex justify-content-between align-items-center" style={{ height: '20px' }}>
        <hr className="flex-fill border-top" />
        <button
          className={`btn btn-collapse btn-lg collapse-icon-end ps-16px fs-12 text-primary${isExpanded ? ' collapsed' : ''}`}
          type="button"
          onClick={handleToggleExpand}
          data-bs-toggle="collapse"
          data-bs-target={`#collapse-${id}`}
          aria-expanded={isExpanded ? 'true' : 'false'}
          aria-controls={`collapse-${id}`}
          data-e2e={`${dataE2e}-collapsable`}
        >
          {label}
        </button>
        <hr className="flex-fill border-top" />
      </div>

      <div className={`collapse my-4px${isExpanded ? ' show' : ''}`} id={`collapse-${id}`}>
        {children}
      </div>
    </div>
  );
}
